import { defineComponent as _defineComponent } from 'vue'
import DealsApi from '@/modules/deals/services/DealsApi';
import {DealStatus} from '@/modules/deals/enums/DealStatus';
import Deal from '@/models/Deal';
import {getDictionaryByEnumObject} from '@/services/enumTranslator/GetDictionaryByEnumObject';
import EnvironmentService from '@/env/EnvironmentService';
import {computed, ref} from 'vue';
import {editableStatuses, isStatusChangeBlocked} from '@/modules/deals/enums/editableStatuses';
import { useInstance } from '@/composables/useInstance';
import { dateTimeFormat } from '@/composables/useFilters';


export default /*#__PURE__*/_defineComponent({
  __name: 'DealChip',
  props: {
    deal: null,
    disabled: { type: Boolean },
    showDealStage: { type: Boolean },
    contentClass: null
  },
  emits: ["update:status"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:status'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  deal: Deal;
  disabled?: boolean;
  showDealStage?: boolean;
  contentClass?: string;
};





// useInstance() opiera się na getCurrentInstance(), więc musi zostać wywołane w setupie.
// Wywołane w handlerze zdarzenia rzucało wyjątkiem PRZED requestem, więc status nigdy się nie zapisywał.
const { $errorHandler } = useInstance();

const stages = getDictionaryByEnumObject<DealStatus>(JSON.parse(JSON.stringify(DealStatus)), 'DealStatus')
  ?.filter(item => {
    return !EnvironmentService.Environment.isAppDomain().NESTO_RO || item.type !== DealStatus.RETURNED_TO_AGENT_CC;
  });

// Keep the pre-#5086 dictionary order for both display and backward-transition checks.
// Product-specific editableStatuses is only a filter, not an ordered workflow.
const statusOrder = stages.map(item => item.type);
const getStatuses = computed(() => stages.filter(item => editableStatuses(props.deal.productType!).includes(item.type)));

const isUpdatingStatus = ref<boolean>(false);

const isStatusDisabled = (statusType: DealStatus): boolean =>
  isUpdatingStatus.value || isStatusChangeBlocked(statusOrder, props.deal.status, statusType);

const isDealEditable = computed<boolean>(() => {
  return !props.disabled && props.deal.userCanEdit.STATUS;
});

// Menu zamyka się po kliknięciu, ale request jeszcze leci — bez tej blokady druga zmiana wystartowałaby
// równolegle i rollback starszego (przegranego) żądania nadpisałby status zapisany przez nowsze.
const updateStatus = async(statusType: DealStatus) => {
  if (isUpdatingStatus.value) {
    return;
  }
  isUpdatingStatus.value = true;
  const previousStatus = props.deal.status;
  props.deal.status = statusType;
  try {
    await DealsApi.updateDealStatus(props.deal.id, statusType);
    emit('update:status');
  } catch (error) {
    props.deal.status = previousStatus;
    $errorHandler(error);
  } finally {
    isUpdatingStatus.value = false;
  }
};

return { __sfc: true,emit, props, $errorHandler, stages, statusOrder, getStatuses, isUpdatingStatus, isStatusDisabled, isDealEditable, updateStatus, DealStatus, dateTimeFormat }
}

})